import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "../../services/axios";
import NoChallengesModal from "../../components/modal/noChallenges";

import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";

import SexRouletteWheel from "../../components/sexRoulette/roulette";
import SexRouletteChallenge from "../../components/sexRoulette/challenge";

export default function SexRouletteGame() {
  const navigate = useNavigate();
  const { categories } = useLocation().state;
  const { t } = useTranslation();

  const challengeContainer = useRef(null);
  const buttonContainerRef = useRef(null);
  const rouletteContainer = useRef(null);

  const { player1: p1, player2: p2 } = useSelector((state) => state.players);

  const [player1, setPlayer1] = useState({
    image: p1.avatar,
    name: p1.name || "",
    genre: p1.gender,
  });
  const [player2, setPlayer2] = useState({
    image: p2.avatar,
    name: p2.name || "",
    genre: p2.gender,
  });
  const [playedChallenges, setPlayedChallenges] = useState([]);
  const [currentChallenge, setCurrentChallenge] = useState({});
  const [currentCategory, setCurrentCategory] = useState({});
  const [ended, setEnded] = useState(false);

  const handleRouletteFinished = () => {
    challengeContainer.current.classList.add("peak");
    setTimeout(() => {
      rouletteContainer.current.classList.add("hide");
      challengeContainer.current.classList.remove("peak");
      challengeContainer.current.classList.add("show");
    }, 2000);
  };

  const handleRouletteStart = (winner) => {
    setCurrentCategory(winner);
  };

  useEffect(() => {
    if (currentCategory?.id_item_cenas) {
      prepareChallenge();
    }
  }, [currentCategory]);

  const getChallenge = (player1, player2) => {
    axios
      .post("/cenas/getChallenge", {
        category: currentCategory?.id_item_cenas,
        exclude: playedChallenges,
        player1: player1,
        player2: player2,
      })
      .then((response) => {
        const { data } = response;
        if (Array.isArray(data) && data.length) {
          setCurrentChallenge(data[0]);
          setPlayedChallenges([...playedChallenges, data[0].id_cena]);
        } else {
          setEnded(true);
        }
      });
  };

  const prepareChallenge = () => {
    const p1 = { ...player1 };
    const p2 = { ...player2 };

    setPlayer1(p2);
    setPlayer2(p1);

    getChallenge(p2.genre, p1.genre);
  };

  const handleNextChallenge = () => {
    challengeContainer.current.classList.remove("show");
    setTimeout(() => {
      rouletteContainer.current.classList.remove("hide");
      setTimeout(() => {
        buttonContainerRef.current.classList.remove("animate");
      }, 1000);
    }, 1000);
    prepareChallenge();
  };

  const handleRestart = () => {
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  const handleGoBack = () => {
    setEnded(false);
    navigate("/sex-roulette");
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={BackHeaderLeft} HeaderCenter={() => {}} />
      <NoHeaderScroll className="no-scroll ps-5 pe-5">
        {useMemo(() => {
          return (
            <SexRouletteWheel
              innerRadius={10}
              rewards={categories}
              onStart={handleRouletteStart}
              onFinished={handleRouletteFinished}
              buttonContainerRef={buttonContainerRef}
              containerRef={rouletteContainer}
            />
          );
        }, [categories, rouletteContainer])}

        <SexRouletteChallenge
          player1={player1}
          player2={player2}
          containerRef={challengeContainer}
          challenge={currentChallenge}
          onNext={handleNextChallenge}
        />
        <NoChallengesModal
          visible={ended}
          button1={t("restart")}
          button2={t("objects")}
          text1={t("dialogText1NaughtyGames")}
          text2={t("dialogText2NaughtyGames")}
          title={t("noChallenges")}
          handleRestart={handleRestart}
          handleGoBack={handleGoBack}
        />
      </NoHeaderScroll>
    </div>
  );
}
